import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import SimpleThread from '../SimpleThread';
import s from './CardLayoutThread.scss';
var CardLayoutThread = function (props) {
    return (React.createElement(SimpleThread, __assign({}, props, { className: classnames(s['card-layout'], props.className), commentBoxWrapperClassName: s['commentbox-wrapper'], threadStackClassName: s['thread-stack'], headerClassName: s['header'], scrollableClassName: s['scrollable'], replyIndentModifier: 0 })));
};
CardLayoutThread.displayName = 'CardLayoutThread';
export default CardLayoutThread;
//# sourceMappingURL=CardLayoutThread.js.map